
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["clamp","linearInterpolate","PixelGeneratorResult","PixelGenerator","calculateBase64"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "8136daaf7b9b6e1dd8ef.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			